import React, { useState, useEffect } from 'react';
import { IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfoV2 } from 'backend/categories';
import FormSelect from 'components/Select/FormSelect';
import style from './SuggestedDishCategorySelect.module.scss';

interface IProps {
	setSuggestedDishCategory: (value: Nullable<string>) => void;
	IDsSelectedRestaurant: string[];
}

export const SuggestedDishCategorySelect: React.FC<IProps> = React.memo(
	({ setSuggestedDishCategory, IDsSelectedRestaurant }) => {
		const [isFirstRender, setIsFirstRender] = useState(true);
		const { response, loading, refetch, responseError } = useFetchData<
			IGetCategoriesShortResponse,
			IGetCategoriesShort
		>(IDsSelectedRestaurant.length ? getCategoriesShortInfoV2 : null, { restaurantIds: IDsSelectedRestaurant });

		useEffect(() => {
			if (isFirstRender) {
				setIsFirstRender(false);
			} else {
				refetch();
			}
		}, [IDsSelectedRestaurant]);

		return (
			<FormSelect
				name="selectedSuggestedDishCategory"
				label="categoryLabel"
				formItemClassName={style.container}
				options={response?.data.categories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!IDsSelectedRestaurant.length || loading}
				onChange={setSuggestedDishCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
